import * as React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { useModal } from '@common/react/components/Modal/ModalContextProvider';

enum AlertType {
	Alert = 0,
	Success = 1,
	Error = 2,
}

interface AlertNotification {
	content: string;
	title: string;
	alertType: AlertType;
}

interface AlertNotificationHandlerProps {
	objectType?: string
}

export const AlertNotificationHandler: React.FC<AlertNotificationHandlerProps> = ({
	objectType = 'AlertNotification',
}) => {
	const { subscribeUntilLogout } = useApplicationContext();
	const { openSuccess, openAlert, openError } = useModal();

	subscribeUntilLogout((notification) => {
		const data = notification?.data as AlertNotification;

		if (notification.objectType === objectType) {
			if (data.alertType === AlertType.Alert) {
				openAlert(data);
			} else if (data.alertType === AlertType.Success) {
				openSuccess(data);
			} else if (data.alertType === AlertType.Error) {
				openError(data);
			}
		}
	});

	return <></>;
};
